export default {
  async mounted () {
    this.$cookies.set('lang', 'fa')
    await this.$store.dispatch('coins/assetCoins')
    await this.$store.dispatch('coins/getDollarPrice', process.env.BASE_URL_UUID)
  }
}
